import React from "react";

type LinkedTextProps = {
  text: string;
  className?: string;
};

const urlRegex = /(https?:\/\/[^\s]+)/g;

const cleanUrl = (value: string) => value.replace(/[),.;!?]+$/g, "");

const LinkedText = ({ text, className = "" }: LinkedTextProps) => {
  const parts = text.split(urlRegex);

  return (
    <div className={`whitespace-pre-wrap ${className}`}>
      {parts.map((part, index) => {
        if (!urlRegex.test(part)) {
          urlRegex.lastIndex = 0;
          return <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>;
        }

        urlRegex.lastIndex = 0;
        const url = cleanUrl(part);
        const trailing = part.slice(url.length);

        return (
          <React.Fragment key={`${part}-${index}`}>
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className="font-black text-[#155EEF] underline decoration-2 underline-offset-4 transition hover:text-[#0B3B9E]"
            >
              {url}
            </a>
            {trailing}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LinkedText;
